/**
 * contains the abi and contract address
*/

class GuildsIndexContract {
    constructor() {
        this.abi = [
	{
		"constant": false,
		"inputs": [
			{
				"internalType": "uint32",
				"name": "guildId",
				"type": "uint32"
			},
			{
				"internalType": "bytes32",
				"name": "ipfsHash",
				"type": "bytes32"
			}
		],
		"name": "newIndex",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "guildsAddress",
				"type": "address"
			}
		],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "constructor"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "uint32",
				"name": "guildId",
				"type": "uint32"
			},
			{
				"indexed": false,
				"internalType": "bytes32",
				"name": "indexHash",
				"type": "bytes32"
			}
		],
		"name": "NewIndex",
		"type": "event"
	}
        ];

        this.contractAddress = '0xefBe8bf3720fE3aD117B1397DD95c77240Fe8837';
    }

    getContract(web3) {
        console.log('getting contract w address = ' + this.contractAddress);
        return new web3.eth.Contract(this.abi, this.contractAddress);
    }
}

export default GuildsIndexContract;
